import Vue from 'vue'

// Load components dynamically.
const requireContext = require.context('./', false, /.*\.vue$/)

const compo = requireContext.keys()
    .map(file =>
        Vue.component(file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file).default)
    )